__turbopack_context__.v({
  "active": "Navbar-module__QBvvRW__active",
  "header": "Navbar-module__QBvvRW__header",
  "logo": "Navbar-module__QBvvRW__logo",
  "logoAtlasImg": "Navbar-module__QBvvRW__logoAtlasImg",
  "logoBrand": "Navbar-module__QBvvRW__logoBrand",
  "logoPowered": "Navbar-module__QBvvRW__logoPowered",
  "logoText": "Navbar-module__QBvvRW__logoText",
  "menuClose": "Navbar-module__QBvvRW__menuClose",
  "menuOverlay": "Navbar-module__QBvvRW__menuOverlay",
  "menuToggle": "Navbar-module__QBvvRW__menuToggle",
  "mobileActions": "Navbar-module__QBvvRW__mobileActions",
  "mobileLinks": "Navbar-module__QBvvRW__mobileLinks",
  "mobileMenu": "Navbar-module__QBvvRW__mobileMenu",
  "mobileProfile": "Navbar-module__QBvvRW__mobileProfile",
  "nav": "Navbar-module__QBvvRW__nav",
  "navActions": "Navbar-module__QBvvRW__navActions",
  "navDropdown": "Navbar-module__QBvvRW__navDropdown",
  "navDropdownEmail": "Navbar-module__QBvvRW__navDropdownEmail",
  "navDropdownItem": "Navbar-module__QBvvRW__navDropdownItem",
  "navDropdownItemDanger": "Navbar-module__QBvvRW__navDropdownItemDanger",
  "navLinks": "Navbar-module__QBvvRW__navLinks",
  "navProfile": "Navbar-module__QBvvRW__navProfile",
  "navProfileBtn": "Navbar-module__QBvvRW__navProfileBtn",
  "profileAvatar": "Navbar-module__QBvvRW__profileAvatar",
  "scrolled": "Navbar-module__QBvvRW__scrolled",
});
